import Linkify from 'linkify-react'
import styled from 'styled-components'

import { Box, Flex } from 'app/components/design-system-components'
import {
  GenericModal,
  GenericModalFooter,
} from 'app/components/design-system-components/modals/GenericModal'

const StyledMessageBody = styled(Box)`
  white-space: pre-line;
  overflow-y: auto;
  line-height: ${(props) => props.theme.lineHeights.encrption};
`

interface LogDetailsModalProps {
  details: {
    subject?: string
    body?: string
    recipients?: string
    cc?: string
  }
  onDissmiss: () => void
  onClose: () => void
}

export const LogDetailsModal = ({
  details,
  onDissmiss,
  onClose,
}: LogDetailsModalProps) => {
  const formatEmailField = (prefix: string, data: string) => {
    return `${prefix}${data
      ?.replace(/\s*<([^>]+)>\s*/g, ' ($1)')
      .replace(/\s*,\s*/g, ', ')}`
  }
  return (
    <GenericModal
      onDismiss={onDissmiss}
      title={
        !!details?.subject && <Flex alignItems="center">{details.subject}</Flex>
      }
      withHeading={details?.subject}
      takeMaxHeight={true}
      modalFooter={
        <GenericModalFooter
          secondaryBtnConfig={{
            title: 'Close',
            onClick: onClose,
          }}
        />
      }
    >
      <StyledMessageBody mb={4}>
        {(details?.recipients || details?.cc) && (
          <Box mb={4}>
            {details?.recipients && (
              <Linkify options={{ truncate: 100 }} as="div">
                {formatEmailField('To: ', details.recipients)}
              </Linkify>
            )}

            {details?.cc && (
              <Linkify options={{ truncate: 100 }} as="div">
                {formatEmailField('Cc: ', details.cc)}
              </Linkify>
            )}
          </Box>
        )}

        <Linkify options={{ truncate: 100 }}>{details?.body}</Linkify>
      </StyledMessageBody>
    </GenericModal>
  )
}
